import React, { useState, useEffect } from "react";
import { Row, Col, Accordion, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUserSMEDetails } from "../actions/userActions";
import DashHeader from "./DashHeader";
import UserValidator from "./UserValidator";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import lottie from "lottie-web";
import Reload from "../lottie-files/Reload";
import BulbLoT from "../lottie-files/BulbLoT";
import LegalByteLoT from "../lottie-files/LegalbyteLoT";
import LawyerLoT from "../lottie-files/LawyerLoT";
import LegalFlowLoT from "../lottie-files/LegalFlowLoT";
import DocumentLoT from "../lottie-files/DocumentLoT";
import JourneyLoT from "../lottie-files/JourneyLoT";
import { addToCart } from "../actions/cartActions";
import ToolTip from "./ToolTip";
import { Helmet } from "react-helmet-async";
import ShepTour from "./Shepard-Tours/IntroTour";
import ShepTourMobi from "./Shepard-Tours/IntroTour-Mobile";
import KeyLoT from "../lottie-files/KeyLoT";

function SMEDash({ userInfo }) {
  const dispatch = useDispatch();
  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;
  const [smeName, setSmeName] = useState("");
  const [smeType, setSmeType] = useState("");
  const [smeIndustrySector, setSmeIndustrySector] = useState("");
  const [smeSizeNew, setSmeSize] = useState("");
  const [operationTimeNew, setOperationTime] = useState("");
  const [smeLocationNew, setSmeLocation] = useState("");
  const [smeWebsite, setSmeWebsite] = useState("");
  const [smeDescription, setSmeDescription] = useState("");
  const [smeAddress, setSmeAddress] = useState("");
  const [smeContactNumber, setSmeContactNumber] = useState("");
  const [smeLinkedIn, setSmeLinkedIn] = useState("");
  const [smeVision, setSmeVision] = useState("");
  const [profileReset, setProfileReset] = useState(true);
  const [updateSMEInfoButton, setUpdateSMEInfoButton] = useState(1);
  const [healthExpanded, setHealthExpanded] = useState(false);

  /* Subscribe Functionality Paused for now */
  const addToCartHandler = () => {
    dispatch(addToCart());
  };

  useEffect(() => {
    dispatch(getUserSMEDetails());
    // eslint-disable-next-line
  }, [profileReset]);

  useEffect(() => {
    setSmeSize(sme.smeSizeNew);
    setOperationTime(sme.operationTimeNew);
    setSmeLocation(sme.smeLocationNew);
    setSmeName(sme.name);
    setSmeType(sme.type);
    setSmeIndustrySector(sme.industry);
    setSmeWebsite(sme.website);
    setSmeDescription(sme.description);
    setSmeAddress(sme.address);
    setSmeContactNumber(sme.contactNumber);
    setSmeLinkedIn(sme.linkedIn);
    setSmeVision(sme.vision);
  }, [sme]);

  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo?.token}`,
    },
  };

  function toggleHealth() {
    setHealthExpanded((prevHealth) => !prevHealth);
    console.log("healthExpanded", healthExpanded);
  }
  const submitHandler = (e) => {
    e.preventDefault();
    axios
      .put(
        "/api/users/update-sme/",
        {
          id: sme.id,
          name: smeName,
          type: smeType,
          address: smeAddress,
          industry: smeIndustrySector,
          website: smeWebsite,
          contactNumber: smeContactNumber,
          linkedIn: smeLinkedIn,
          description: smeDescription,
          vision: smeVision,
          smeSizeNew: sme.smeSizeNew,
          operationTimeNew: operationTimeNew,
          smeLocationNew: smeLocationNew,
        },
        config
      )
      .then(function (response) {
        console.log("Response Received");
        setUpdateSMEInfoButton(2);
        setProfileReset((oldProfile) => !oldProfile);
      })
      .catch(function (error) {
        console.log("Error Occured");
      });
  };

  // useEffect(() => {
  //   if (!userInfo || userInfo?.profile === 0) {
  //     navigate("/dashboard/validate");
  //   }
  // }, [userInfo]);

  return (
    <>
      <Helmet>
        <title>Lacoona Legal Dashboard</title>
        <meta
          name="description"
          content="You centalised Legal Dashboard for managing your business on Lacoona Legal"
        />
        <link rel="canonical" href={"/dashboard/sme-profile"} />
      </Helmet>
      {userInfo?.profile === 1 && (
        <Col className="dashboard-scrollable-container" lg={9}>
          <DashHeader pageTitle={"Welcome " + userInfo.name} />
          <Row className="dashboard-content-container">
            <Row className="dashboard-content-divider"></Row>

            <Col className="px-4">
              {/* Reece Alt Dashboard UI */}
              {/* Title */}
              <Row className="mb-3">
                <Col xs={6} md={8} lg={10}>
                  <h2 className="ll-subtitle ll-feat-font">Dashboard</h2>
                </Col>
                <Col className="tour-bicycle" xs={6} md={4} lg={2}>
                  <ShepTourMobi />
                  <ShepTour />
                </Col>
              </Row>
              {/* Body Content */}
              <Row className="ll-dash-body-content">
                <Row className="ll-dash-top-content">
                  <Col className="ll-dash-metrics-parent">
                    {/* Conditional start your journey */}
                    {!sme?.legalHealth ? (
                      <Row
                        className="start-your-journey-parent my-3"
                        onMouseEnter={() => lottie.play("journey-start-dash")}
                        onMouseLeave={() => lottie.stop("journey-start-dash")}
                      >
                        <Col className="sme-journey-col pe-2">
                          <Row>
                            <h6 className="start-you-journey-text">
                              Take our legal health assessment to complete your
                              profile!
                            </h6>
                          </Row>
                          <Row className="journey-start-dash-parent">
                            <JourneyLoT aniName="journey-start-dash" />
                          </Row>
                          <Row className="px-3">
                            <LinkContainer to={`/dashboard/health-check`}>
                              <button className="lcn-button-orange px-5">
                                Go
                              </button>
                            </LinkContainer>
                          </Row>
                        </Col>
                        {sme?.tokenCount <= 3 && (
                          <Col className="sme-token-col">
                            <Row>
                              <h6 className="start-you-journey-text">
                                Upgrade your account for unlimited access to our
                                legal tools!
                              </h6>
                            </Row>
                            <Row className="sme-token-number-row">
                              <span className="sme-token-number">
                                {sme?.tokenCount}
                              </span>
                            </Row>
                            <Row>
                              <h6 align="center">Credits</h6>
                            </Row>
                            <Row className="px-2">
                              <LinkContainer to={"/pricing"}>
                                <button className="lcn-button-orange mx-2">
                                  Upgrade
                                </button>
                              </LinkContainer>
                            </Row>

                            <Row></Row>
                          </Col>
                        )}

                        <Row
                          id="divider-under-token"
                          className="dashboard-content-divider"
                        ></Row>
                      </Row>
                    ) : (
                      <div>
                        {/* Alt UI Featured metric Card */}
                        <Row
                          onClick={toggleHealth}
                          className="ll-featured-metric-card ll-card-interact"
                          onMouseEnter={() => lottie.play("update-lh")}
                          onMouseLeave={() => lottie.stop("update-lh")}
                          role="button"
                        >
                          <Row className="ll-featured-metric-card-top-info">
                            <Col>
                              <h4 className="ll-feature-card-subtext">
                                Overall Legal health
                              </h4>
                            </Col>
                            <Col className="d-flex justify-content-end ll-no-margin px-0 mx-0">
                              <LinkContainer to={"/dashboard/health-check"}>
                                <Reload aniName="update-lh" />
                              </LinkContainer>
                            </Col>
                          </Row>
                          <Row className="ll-featured-metric-card-bottom-info">
                            <Col className="align-content-end">
                              <Row className="align-text-bottom">
                                <Col className="ll-featured-card-metric-number ll-feat-font">
                                  {sme ? sme.legalHealth : "."}
                                  <span className="ll-featured-card-metric-percent ll-feat-font">
                                    %
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            <Col className="ll-metric-card-date">
                              <h4 className="ll-featured-card-metric-last-checked ll-feature-card-subtext">
                                Last checked on
                              </h4>
                              <h4 className="ll-featured-card-metric-date ll-feature-card-subtext">
                                {sme.lastHealthCheck}
                              </h4>
                            </Col>
                          </Row>
                        </Row>
                        {/* AltUI Metric Card */}
                        {!healthExpanded && (
                          <div
                            onClick={toggleHealth}
                            className="drop-down-parent"
                          >
                            <i class=" arrow-down fa-solid fa-circle-chevron-down"></i>
                          </div>
                        )}

                        {healthExpanded && (
                          <Row align="center" className="parent-sub-scores">
                            <div
                              onClick={toggleHealth}
                              className="drop-down-parent"
                            >
                              <i class="arrow-down arrow-up fa-solid fa-circle-chevron-up"></i>
                            </div>
                            <Row className="ll-metric-card-container ">
                              <Row
                                className="ll-metric-card ll-card-interact sub-score"
                                onMouseEnter={() => lottie.play("info-rc")}
                                onMouseLeave={() => lottie.stop("info-rc")}
                              >
                                <Col className="">
                                  <h5 className="ll-no-margin ll-metric-card-text">
                                    Regulatory
                                    <br />
                                    Compliance
                                  </h5>
                                </Col>
                                <Col className="d-flex flex-column w-100 justify-content-center ll-align-items-end">
                                  <div className="text-center justify-content-center">
                                    <span className="ll-feat-font ll-metric-general">
                                      {sme ? sme.regulatoryCompliance : "."}
                                    </span>
                                    <span className="ll-feat-font ll-metric-percentage-general">
                                      %
                                    </span>
                                  </div>
                                </Col>
                                <Col className="d-flex flex-column ll-align-items-end">
                                  <ToolTip
                                    tooltip="This metric is based on your performance in your last Legal Health check"
                                    id="tooltip-reg-comp"
                                    placement="right"
                                  >
                                    <BulbLoT aniName="info-rc" />
                                  </ToolTip>
                                </Col>
                              </Row>
                            </Row>
                            <Row className="ll-metric-card-container ">
                              <Row
                                className="ll-metric-card ll-card-interact sub-score"
                                onMouseEnter={() => lottie.play("info-io")}
                                onMouseLeave={() => lottie.stop("info-io")}
                              >
                                <Col className="">
                                  <h5 className="ll-no-margin ll-metric-card-text">
                                    Internal
                                    <br />
                                    Operations
                                  </h5>
                                </Col>
                                <Col className="d-flex flex-column w-100 justify-content-center ll-align-items-end">
                                  <div className="text-center justify-content-center">
                                    <span className="ll-feat-font ll-metric-general">
                                      {sme ? sme.internalOperations : "."}
                                    </span>
                                    <span className="ll-feat-font ll-metric-percentage-general">
                                      %
                                    </span>
                                  </div>
                                </Col>
                                <Col className="d-flex flex-column ll-align-items-end">
                                  <ToolTip
                                    tooltip="This metric is based on your performance in your last Legal Health check"
                                    id="tooltip-int-op"
                                    placement="right"
                                  >
                                    <BulbLoT aniName="info-io" />
                                  </ToolTip>
                                </Col>
                              </Row>
                            </Row>
                            <Row className="ll-metric-card-container ">
                              <Row
                                className="ll-metric-card ll-card-interact sub-score"
                                onMouseEnter={() => lottie.play("info-eo")}
                                onMouseLeave={() => lottie.stop("info-eo")}
                              >
                                <Col className="">
                                  <h5 className="ll-no-margin ll-metric-card-text">
                                    External
                                    <br />
                                    Operations
                                  </h5>
                                </Col>
                                <Col className="d-flex flex-column w-100 justify-content-center ll-align-items-end">
                                  <div className="text-center justify-content-center">
                                    <span className="ll-feat-font ll-metric-general">
                                      {sme ? sme.externalOperations : "."}
                                    </span>
                                    <span className="ll-feat-font ll-metric-percentage-general">
                                      %
                                    </span>
                                  </div>
                                </Col>
                                <Col className="d-flex flex-column ll-align-items-end">
                                  <ToolTip
                                    tooltip="This metric is based on your performance in your last Legal Health check"
                                    id="tooltip-ext-op"
                                    placement="right"
                                  >
                                    <BulbLoT aniName="info-eo" />
                                  </ToolTip>
                                </Col>
                              </Row>
                            </Row>
                          </Row>
                        )}

                        {/* Investment Readiness Check */}
                        <Row className="ll-featured-metric-card ll-card-interact">
                          <Row className="ll-featured-metric-card-top-info">
                            <Col className="vert-align-start">
                              <h4 className="ll-feature-card-subtext">
                                Investment Readiness
                              </h4>
                            </Col>
                            <Col className="d-flex justify-content-end ll-no-margin px-0 mx-0">
                              {sme.investmentDueDiligence === null ? (
                                <Col align="right" className="vert-align-end">
                                  <LinkContainer
                                    to={"/dashboard/investment-readiness"}
                                  >
                                    <div
                                      onMouseEnter={() =>
                                        lottie.play("update-ir")
                                      }
                                      onMouseLeave={() =>
                                        lottie.stop("update-ir")
                                      }
                                      className="start-check-button"
                                    >
                                      Start
                                      <Reload aniName="update-ir" />
                                    </div>
                                  </LinkContainer>
                                </Col>
                              ) : (
                                <Col className="ll-metric-card-date">
                                  <Col className="align-content-end vert-align-end">
                                    <Row className="align-text-bottom">
                                      <Col
                                        id="investment-score"
                                        className="ll-featured-card-metric-number ll-feat-font"
                                      >
                                        {sme ? sme.investmentDueDiligence : "."}
                                        <Reload aniName="update-pc" />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                              )}
                            </Col>
                          </Row>
                          <Row className="ll-featured-metric-card-bottom-info">
                            {/* {sme.investmentDueDiligence===null?
                            <Col >
                            <LinkContainer to={"/dashboard/investment-readiness"} ><button className= "text-center lcn-button-orange">Start</button></LinkContainer>
                            
                            </Col>:
                            <Col className="ll-metric-card-date">
                              <Col className="align-content-end">
                              <Row className="align-text-bottom">
                                <Col id = "investment-score" className="ll-featured-card-metric-number ll-feat-font">
                                  {sme ? sme.investmentDueDiligence : "."}
                                </Col>
                              </Row>
                            </Col>
                            </Col>} */}
                          </Row>
                        </Row>

                        {/* POPI Check */}
                        <Row className="ll-featured-metric-card ll-card-interact">
                          <Row className="ll-featured-metric-card-top-info">
                            <Col className="vert-align-start">
                              <h4 className="ll-feature-card-subtext">
                                POPI Compliance
                              </h4>
                            </Col>
                            <Col className="d-flex justify-content-end ll-no-margin px-0 mx-0">
                              {sme.popiCompliance === null ? (
                                <Col align="right" className="vert-align-end">
                                  <LinkContainer to={"/dashboard/popi"}>
                                    <div
                                      onMouseEnter={() =>
                                        lottie.play("update-pc")
                                      }
                                      onMouseLeave={() =>
                                        lottie.stop("update-pc")
                                      }
                                      className="start-check-button"
                                    >
                                      Start
                                      <Reload aniName="update-pc" />
                                    </div>
                                  </LinkContainer>
                                </Col>
                              ) : (
                                <Col className="ll-metric-card-date">
                                  <h4
                                    id="investment-score"
                                    className="ll-featured-card-metric-number ll-feat-font"
                                  >
                                    {sme.popiCompliance} %
                                    <Reload aniName="update-pc" />
                                  </h4>
                                </Col>
                              )}
                            </Col>
                          </Row>
                        </Row>

                        {sme?.tokenCount <= 3 && (
                          <Row className="ll-metric-card-container">
                            <Row className="ll-metric-card ll-card-interact">
                              <Col className="sme-posthealth-credit-word-col">
                                <h3 className="ll-no-margin ll-metric-card-text">
                                  Credits
                                </h3>
                              </Col>
                              <Col className="d-flex flex-column w-100 justify-content-center ll-align-items-end">
                                <div className="text-center justify-content-center">
                                  <span className="ll-feat-font ll-metric-general">
                                    {sme ? sme.tokenCount : "."}
                                  </span>
                                  <span className="ll-feat-font ll-metric-percentage-general ll-metric-percentage-general-hidden">
                                    %
                                  </span>
                                </div>
                              </Col>
                              <Col className="d-flex flex-column ll-align-items-end sme-posthealth-upgrade-col">
                                <LinkContainer to={"/cart"}>
                                  <div
                                    className="start-check-button me-2"
                                    onClick={addToCartHandler}
                                  >
                                    Upgrade
                                    <KeyLoT aniName="key-upgrade" />
                                  </div>
                                </LinkContainer>
                              </Col>
                            </Row>
                          </Row>
                        )}
                      </div>
                    )}
                    {/* Quick Links */}
                    <Row className="ll-dash-quick-links-parent py-3 ll-no-margin">
                      <Row>
                        <h3 className="ll-feat-font py-2">
                          What can we help you with?
                        </h3>
                      </Row>
                      <Row className="ll-dash-quicklinks-row px-0">
                        <LinkContainer to={"/dashboard/legal-products"}>
                          <Col
                            className="ll-metric-card-container ll-quick-link-card"
                            onMouseEnter={() => lottie.play("document-ql")}
                            onMouseLeave={() => lottie.stop("document-ql")}
                          >
                            <Row className="ll-metric-card p-2 ll-card-interact">
                              <Col
                                className="dash-sidepanel-link-icon-parent"
                                lg={3}
                              >
                                <DocumentLoT aniName="document-ql" />
                              </Col>
                              <Col
                                className="dash-sidepanel-link-text-container"
                                lg={9}
                              >
                                <h3 className="dash-sidepanel-link-text px-2">
                                  Documents
                                </h3>
                              </Col>
                            </Row>
                          </Col>
                        </LinkContainer>
                        <LinkContainer to={"/dashboard/legal-products"}>
                          <Col
                            className="ll-metric-card-container ll-quick-link-card"
                            onMouseEnter={() => lottie.play("legalflow-ql")}
                            onMouseLeave={() => lottie.stop("legalflow-ql")}
                          >
                            <Row className="ll-metric-card p-2 ll-card-interact">
                              <Col
                                className="dash-sidepanel-link-icon-parent"
                                lg={3}
                              >
                                <LegalFlowLoT aniName="legalflow-ql" />
                              </Col>
                              <Col
                                className="dash-sidepanel-link-text-container"
                                lg={9}
                              >
                                <h3 className="dash-sidepanel-link-text px-2">
                                  Legal Flows
                                </h3>
                              </Col>
                            </Row>
                          </Col>
                        </LinkContainer>
                      </Row>
                      <Row className="ll-dash-quicklinks-row px-0">
                        <LinkContainer to={"/dashboard/faqs"}>
                          <Col
                            className="ll-metric-card-container ll-quick-link-card"
                            onMouseEnter={() => lottie.play("legalbyte-ql")}
                            onMouseLeave={() => lottie.stop("legalbyte-ql")}
                          >
                            <Row className="ll-metric-card p-2 ll-card-interact">
                              <Col
                                className="dash-sidepanel-link-icon-parent"
                                lg={3}
                              >
                                <LegalByteLoT aniName="legalbyte-ql" />
                              </Col>
                              <Col
                                className="dash-sidepanel-link-text-container"
                                lg={9}
                              >
                                <h3 className="dash-sidepanel-link-text px-2">
                                  Legal Bytes
                                </h3>
                              </Col>
                            </Row>
                          </Col>
                        </LinkContainer>
                        <LinkContainer to={"/dashboard/find-a-lawyer"}>
                          <Col
                            className="ll-metric-card-container ll-quick-link-card"
                            onMouseEnter={() => lottie.play("lawyer-ql")}
                            onMouseLeave={() => lottie.stop("lawyer-ql")}
                          >
                            <Row className="ll-metric-card p-2 ll-card-interact">
                              <Col
                                className="dash-sidepanel-link-icon-parent"
                                lg={3}
                              >
                                <LawyerLoT aniName="lawyer-ql" />
                              </Col>
                              <Col
                                className="dash-sidepanel-link-text-container"
                                lg={9}
                              >
                                <h3 className="dash-sidepanel-link-text px-2">
                                  Find a lawyer
                                </h3>
                              </Col>
                            </Row>
                          </Col>
                        </LinkContainer>
                      </Row>
                    </Row>
                  </Col>

                  {/* Company details section */}
                  <Col className="ll-dash-company-details p-2 px-4">
                    <Row>
                      <h3 className="ll-feat-font">Company Information</h3>
                    </Row>
                    <Row className="py-4">
                      <Col>
                        <div>
                          <h5>{sme ? sme.name : "."}</h5>
                        </div>
                        <div className="ll-grey-colour ">
                          <h5 className="ll-font-wt-light">Company Name</h5>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h5>{sme ? sme.type : "."}</h5>
                        </div>
                        <div className="ll-grey-colour ">
                          <h5 className="ll-font-wt-light">
                            Organisation Type
                          </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row className="py-4">
                      <Col>
                        <div>
                          <h5>{sme ? sme.industry : "."}</h5>
                        </div>
                        <div className="ll-grey-colour ">
                          <h5 className="ll-font-wt-light">Industry</h5>
                        </div>
                      </Col>
                    </Row>
                    <Row className="py-4">
                      <Accordion>
                        <Accordion.Item
                          eventKey="0"
                          className="ll-accordion-parent"
                        >
                          <Accordion.Header>
                            Update Company Details
                          </Accordion.Header>
                          <Accordion.Body>
                            <Form onSubmit={submitHandler}>
                              <Form.Group className="mb-3" controlId="smeName">
                                <Form.Label>Company Name</Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Enter company name"
                                  value={smeName ? smeName : ""}
                                  onChange={(e) => setSmeName(e.target.value)}
                                />
                              </Form.Group>
                              <Form.Group className="mb-3" controlId="smeType">
                                <Form.Label>Company Type</Form.Label>
                                <Form.Select
                                  value={smeType ? smeType : ""}
                                  aria-label="Default select example"
                                  onChange={(e) => setSmeType(e.target.value)}
                                >
                                  <option value="Sole Trader">
                                    Sole Trader
                                  </option>
                                  <option value="Partnership">
                                    Partnership
                                  </option>
                                  <option value="Company">Company</option>
                                  <option value="Public Benefit/Non-profit">
                                    Public Benefit/Non-profit
                                  </option>
                                  <option value="Trust">Trust</option>
                                  <option value="Other">Other</option>
                                </Form.Select>
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="smeIndustrySector"
                              >
                                <Form.Label>Company Industry Sector</Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  onChange={(e) =>
                                    setSmeIndustrySector(e.target.value)
                                  }
                                  value={
                                    smeIndustrySector ? smeIndustrySector : ""
                                  }
                                >
                                  <option value="Tech, Media, and Publishing">
                                    Tech, Media, and Publishing
                                  </option>
                                  <option value="Marketing">Marketing</option>
                                  <option value="Production">Production</option>
                                  <option value="Fashion and Design">
                                    Fashion and Design
                                  </option>
                                  <option value="Human resources and recruitment">
                                    Human resources and recruitment
                                  </option>
                                  <option value="Leisure and Fitness">
                                    Leisure and Fitness
                                  </option>
                                  <option value="Financial Services">
                                    Financial Services
                                  </option>
                                  <option value="Property">Property</option>
                                  <option value="Business Services">
                                    Business Services
                                  </option>
                                  <option value="General Freelancer">
                                    General Freelancer
                                  </option>
                                </Form.Select>
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="smeLocationNew"
                              >
                                <Form.Label>Company Location</Form.Label>
                                <Form.Control
                                  type="input"
                                  value={smeLocationNew ? smeLocationNew : ""}
                                  onChange={(e) =>
                                    setSmeLocation(e.target.value)
                                  }
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="websiteURL"
                              >
                                <Form.Label>Company Website URL</Form.Label>
                                <Form.Control
                                  type="input"
                                  value={smeWebsite ? smeWebsite : ""}
                                  onChange={(e) =>
                                    setSmeWebsite(e.target.value)
                                  }
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="contactNumber"
                              >
                                <Form.Label>Company Contact Number</Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Enter company contact number"
                                  value={
                                    smeContactNumber ? smeContactNumber : ""
                                  }
                                  onChange={(e) =>
                                    setSmeContactNumber(e.target.value)
                                  }
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="linkedInProfile"
                              >
                                <Form.Label>
                                  Company LinkedIn Profile
                                </Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Enter the URL for yor company's LinkedIn profile"
                                  value={smeLinkedIn ? smeLinkedIn : ""}
                                  onChange={(e) =>
                                    setSmeLinkedIn(e.target.value)
                                  }
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="smeDescription"
                              >
                                <Form.Label>Company Description</Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Enter a new description for your company"
                                  value={smeDescription ? smeDescription : ""}
                                  onChange={(e) =>
                                    setSmeDescription(e.target.value)
                                  }
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="smeVision"
                              >
                                <Form.Label>Company Vision</Form.Label>
                                <Form.Control
                                  type="input"
                                  value={smeVision ? smeVision : ""}
                                  onChange={(e) => setSmeVision(e.target.value)}
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="smeSizeNew"
                              >
                                <Form.Label>Company Size</Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Update your employee number"
                                  value={smeSizeNew ? smeSizeNew : ""}
                                  onChange={(e) => setSmeSize(e.target.value)}
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-3"
                                controlId="operationTimeNew"
                              >
                                <Form.Label>Company Age</Form.Label>
                                <Form.Control
                                  type="input"
                                  placeholder="Update your company age"
                                  value={
                                    operationTimeNew ? operationTimeNew : ""
                                  }
                                  onChange={(e) =>
                                    setOperationTime(e.target.value)
                                  }
                                />
                              </Form.Group>
                              <Row>
                                {updateSMEInfoButton === 1 ? (
                                  <Col align="end">
                                    <button
                                      className="lcn-button-brown px-5 py-3"
                                      type="submit"
                                    >
                                      Update
                                    </button>
                                  </Col>
                                ) : (
                                  <Col align="center">
                                    <h3>Updated!</h3>
                                  </Col>
                                )}
                              </Row>
                            </Form>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Row>
                    <Row>
                      <LinkContainer to={"/dashboard/profile"}>
                        <button className="lcn-button-brown">
                          Update user details
                        </button>
                      </LinkContainer>
                    </Row>

                    <Row>
                      <Col className="ll-dash-activity-details"></Col>
                    </Row>
                  </Col>
                </Row>
                {/* More Content Space for later */}
                <Row className="ll-dash-bottom-content"></Row>
              </Row>
              {/* End of Reece Attempt */}
            </Col>
          </Row>
        </Col>
      )}
      {!userInfo ? (
        <UserValidator />
      ) : (
        userInfo?.profile === 0 && <UserValidator />
      )}
    </>
  );
}

export default SMEDash;
